import * as React from 'react';

import type { VariantProps } from 'tailwind-variants';
import { tv } from 'tailwind-variants';

import { cn } from '@avodah-inc/ui/utils';

const questionCircleFilledVariants = tv({
  base: 'text-base-black',
  variants: {
    variant: {
      default: 'text-base-black',
      onDark: 'text-base-white',
      primary: 'text-primary',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

export type QuestionCircleFilledProps = {
  width?: string | number;
  height?: string | number;
  viewBox?: string;
  fill?: string;
} & React.SVGAttributes<SVGSVGElement> &
  VariantProps<typeof questionCircleFilledVariants>;

const QuestionCircleFilled = React.forwardRef<
  SVGSVGElement,
  QuestionCircleFilledProps
>(
  (
    {
      className,
      variant,
      viewBox,
      width,
      height,
      fill = 'currentColor',
      ...props
    },
    ref,
  ) => {
    return (
      <svg
        className={cn(
          questionCircleFilledVariants({
            variant,
            className,
          }),
        )}
        fill={fill}
        height={height}
        ref={ref}
        viewBox={viewBox ?? '0 0 24 24'}
        width={width}
        {...props}
      >
        <path
          d="M12 2.40002C14.5461 2.40002 16.9879 3.41145 18.7882 5.2118C20.5886 7.01215 21.6 9.45395 21.6 12C21.6 14.5461 20.5886 16.9879 18.7882 18.7882C16.9879 20.5886 14.5461 21.6 12 21.6C9.45392 21.6 7.01212 20.5886 5.21178 18.7882C3.41143 16.9879 2.4 14.5461 2.4 12C2.4 9.45395 3.41143 7.01215 5.21178 5.2118C7.01212 3.41145 9.45392 2.40002 12 2.40002ZM12 16.2C11.7613 16.2 11.5324 16.2948 11.3636 16.4636C11.1948 16.6324 11.1 16.8613 11.1 17.1C11.1 17.3387 11.1948 17.5676 11.3636 17.7364C11.5324 17.9052 11.7613 18 12 18C12.2387 18 12.4676 17.9052 12.6364 17.7364C12.8052 17.5676 12.9 17.3387 12.9 17.1C12.9 16.8613 12.8052 16.6324 12.6364 16.4636C12.4676 16.2948 12.2387 16.2 12 16.2ZM12 6.60002C11.2044 6.60002 10.4413 6.9161 9.87868 7.4787C9.31607 8.04131 9 8.80438 9 9.60002C9 9.75915 9.06321 9.91177 9.17574 10.0243C9.28826 10.1368 9.44087 10.2 9.6 10.2C9.75913 10.2 9.91174 10.1368 10.0243 10.0243C10.1368 9.91177 10.2 9.75915 10.2 9.60002C10.2 9.30931 10.2704 9.02292 10.4051 8.76534C10.5399 8.50776 10.7351 8.28665 10.9739 8.12093C11.2128 7.95521 11.4882 7.84981 11.7767 7.81374C12.0651 7.77767 12.358 7.812 12.6303 7.91381C12.9026 8.01561 13.1462 8.18185 13.3403 8.39832C13.5343 8.61478 13.6731 8.87502 13.7446 9.15679C13.8162 9.43856 13.8184 9.73347 13.7512 10.0163C13.6839 10.2991 13.5491 10.5614 13.3584 10.7808L13.2312 10.9128L13.0896 11.0328L12.7932 11.2548C12.641 11.3728 12.4982 11.5024 12.366 11.6424C11.7516 12.2976 11.4 13.1856 11.4 14.4C11.4 14.5592 11.4632 14.7118 11.5757 14.8243C11.6883 14.9368 11.8409 15 12 15C12.1591 15 12.3117 14.9368 12.4243 14.8243C12.5368 14.7118 12.6 14.5592 12.6 14.4C12.6 13.4904 12.8352 12.8952 13.242 12.4632L13.332 12.372L13.428 12.2844L13.5336 12.198L13.7964 12.0024L13.9812 11.8524C14.4389 11.4497 14.7631 10.9172 14.9105 10.3256C15.058 9.73408 15.0217 9.11166 14.8066 8.54124C14.5914 7.97083 14.2076 7.47951 13.7062 7.13271C13.2048 6.78592 12.6096 6.6001 12 6.60002Z"
          fill="currentColor"
        />
      </svg>
    );
  },
);

QuestionCircleFilled.displayName = 'QuestionCircleFilled';

export { QuestionCircleFilled, questionCircleFilledVariants };
